import { render } from "./Univ-Dean-Details.vue?vue&type=template&id=4b35c1c2&scoped=true"
import script from "./Univ-Dean-Details.vue?vue&type=script&lang=js"
export * from "./Univ-Dean-Details.vue?vue&type=script&lang=js"

import "./Univ-Dean-Details.vue?vue&type=style&index=0&id=4b35c1c2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4b35c1c2"

export default script